import ExternalApiRequest from "./../utils/ExternalApiRequest";
import actionTypes from "./../constants/actionTypes";
import { getList } from "./formActions";
import { toast } from 'react-toastify';
import { clearFormCache, getUserFromToken, removeLoginToken, setLoginToken } from "../utils/utility";

export const userLogin = (payload) => {
    try {
        return async dispatch => {
            let options = {
                api: "userLogin",
                content: payload
            };
            let response = await ExternalApiRequest(options);
            const { payload: userResponse = {} } = response;
            const { user = {} } = userResponse;
            const { token = '' } = user;
            setLoginToken(token);
            return dispatch({
                type: actionTypes.USER.LOGIN,
                payload: user,
            });
        }
    } catch (error) {
        console.log(error);
    }
};

export const userLogout = () => {
    try {
        return async dispatch => {
            removeLoginToken();
            await clearFormCache();
            return dispatch({
                type: actionTypes.USER.LOGIN,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
};

export const listUsers = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "listUser", "users");
            const listJson = formListJson(formData, listResponse);
            return dispatch({
                type: actionTypes.USER.USER_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

const formListJson = (formPayload, listPayload) => {
    const { data = {}, meta = {} } = formPayload;
    const { users = [], meta: listMeta = {} } = listPayload;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    const listData = users.map(user => {
        const { title = '', firstName = '', lastName = '', countryCode = '', mobile = '' } = user;
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case "name": {
                    if (title)
                        value += `${title}. `;
                    if (firstName)
                        value += `${firstName}`;
                    if (lastName)
                        value += `${lastName}`
                    break;
                }
                case "mobile": {
                    value = `${countryCode}-${mobile}`;
                    break;
                }
                case "action": {
                    value = ["edit", "delete"];
                    break;
                }
                default: value = user[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

export const getUserDetails = () => {
    try {
        return async (dispatch, getState) => {
            const user = getUserFromToken();
            const { userId = '' } = user;
            const listResponse = await getList({ userId }, "listUser", "");
            const { payload = {} } = listResponse;
            const { users = [] } = payload;
            const [firstUser = {}] = users;
            return dispatch({
                type: actionTypes.USER.USER_DETAILS_SUCCESS,
                payload: firstUser,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const updateUsers = (requestPayload) => {
    try {
        return async (dispatch, getState) => {
            let options = {
                api: "updateUser",
                content: requestPayload
            };
            let response = await ExternalApiRequest(options);
            const { status = {}, errors = [] } = response;
            const { success = false } = status;
            if (success) {
                toast.success('Successfully Updated');
            } else {
                errors.forEach(errorObj => {
                    const { message = 'Updation failed' } = errorObj;
                    toast.error(message);
                })
            }
        }
    } catch (error) {
        console.log(error);
    }
}

export const zerodhaLogin = () => {
    try {
        return async (dispatch, getState) => {
            const userInfo = getUserFromToken();
            const options = {
                api: 'listConfiguration',
                content: {
                    type: 'ZERODHA'
                }
            };
            const response = await ExternalApiRequest(options);
            const { status = {}, payload = {} } = response;
            const { configurations = [] } = payload;
            const { userId = '' } = userInfo;
            const filteredConfiguration = configurations.filter(config => config.userId === userId);
            const [firstConfig = {}] = filteredConfiguration;
            const { data = {} } = firstConfig;
            const { apiKey = '' } = data;
            if (apiKey)
                window.open(`https://kite.zerodha.com/connect/login?v=3&api_key=${apiKey}`, '_blank');
        }
    } catch (error) {
        console.log(error);
    }
}